@use "@inshared/ui-foundation/css/tokens/border-radius";
@use "@inshared/ui-foundation/css/tokens/border-width";
@use "@inshared/ui-foundation/css/tokens/breakpoints";
@use "@inshared/ui-foundation/css/tokens/color";
@use "@inshared/ui-foundation/css/tokens/spacing";

:host {
    --animation: none;
    position: fixed;
    display: none;
    opacity: 0;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    inset: 0;
    background-color: rgb(0, 0, 0, 32%);
    z-index: 1000;
    transition:
        opacity 0.4s cubic-bezier(0.25, 0.8, 0.25, 1),
        display 0.4s; // see "allow-discrete" below

    .web-overlay-backdrop {
        position: fixed;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
    }

    .web-overlay-container {
        display: flex;
        border: border-width.$sm solid color.$color-background-300;
        border-radius: border-radius.$xl;
        background: white;
        max-height: 100%;
        box-shadow: 0 1rem 2rem #585750;
        width: 100%;
        padding: 0;
        flex-direction: column;
        z-index: 1001;
        animation: var(--animation) 0.3s ease-out forwards;

        .web-overlay-header {
            padding: 2rem;
            display: flex;
            justify-content: flex-end;
            height: 7.4rem;
            box-sizing: border-box;
            border-bottom: 0.3rem solid #f6f6f6;
        }

        .web-overlay-content {
            max-height: 100%;
            flex: 1;
        }

        &:has(.web-overlay-header) .web-overlay-content {
            max-height: calc(100% - 7.4rem);
        }

        .web-overlay-close {
            position: absolute;
            right: 0;
            top: #{spacing.$lg};
        }

        &.full-screen {
            height: 100%;
        }

        @media (min-width: breakpoints.$screen-md-min) {
            width: breakpoints.$screen-md-min;
            max-height: 95%;

            &.full-screen {
                height: auto;
            }
        }
    }
}

// regular dialog animations, scale in and out

@keyframes scaleup {
    from {
        scale: 0;
    }
}

@keyframes scaledown {
    to {
        scale: 0;
    }
}

:host(.web-overlay--opened) {
    transition-behavior: allow-discrete;
    display: flex;
    opacity: 1;
    --animation: scaleup;
}

:host(.web-overlay--closed) {
    transition-behavior: allow-discrete;
    display: none;
    opacity: 0;
    --animation: scaledown;
}

// anchored dialog animations, slide up and down

:host([anchored]) {
    background-color: transparent;

    .web-overlay-container {
        top: initial;
        inset-inline: 0;
        translate: 0;
        bottom: 0;
        border-radius: 0;
        width: 100%;
    }
}

@keyframes slide-up {
    from {
        transform: translateY(100%);
    }
}

@keyframes slide-down {
    to {
        transform: translateY(100%);
    }
}

:host(.web-overlay--opened[anchored]) {
    --animation: slide-up;
}

:host(.web-overlay--closed[anchored]) {
    --animation: slide-down;
}
